<template>
  <div class="hero-static">
    <div class="content verify-footer">
      <div class="row justify-content-center">
        <div class="col-md-8 col-lg-6 col-xl-6">
          <div class="block block-themed block-fx-shadow mb-0">
            <div class="block-header bg-success">
              <h3 class="block-title">Email Verification</h3>
              <div class="block-options">
                <router-link class="btn-block-option js-tooltip-enabled" to="/login" title="Sign In">
                  <i class="fa fa-sign-in-alt"></i>
                </router-link>
              </div>
            </div>
            <div class="block-content">
              <div class="verify-content">
                <p v-if="statusMsg">{{ statusMsg }}</p>
                <p v-if="showLoginLink">Click <router-link to="/login">here</router-link> to login.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer/>
  </div>
</template>

<script>
import Footer from '@/components/Footer';
import { helper } from '@/helper.js';

export default {
  name: 'Verify',
  data() {
    return {
      statusMsg: 'Verifying...',
      showLoginLink: false
    };
  },
  components: {
    Footer
  },
  mounted() {
    let vm = this;
    helper.sendPostRequest('/signup/verify',
      {'key': vm.$route.params.key},
      { headers: vm.getAuthHeader() })
      .then(function(data){
        if (data.status === 'success') {
          vm.showLoginLink = true;
        }
        vm.statusMsg = data.message;    
      }).catch(function(){
        vm.statusMsg = 'Email verification failed.';
      });
  }
};
</script>

<style>
.verify-content {
  padding: 1rem;
}
.verify-footer {
  min-height: calc(100vh - 61px);
  padding-bottom: 2rem;    
}
</style>


// WEBPACK FOOTER //
// source/components/Verify.vue